import React, { useMemo } from 'react';
import { startCase } from 'lodash';
import { OpenInNew } from '@material-ui/icons';
import { ModalTitle } from '@/styles/blocks';

const LINK_ATTRS = [
    { meta: 'middle_mile_integration_meta', type: 'middle_mile_integration_type' },
    { meta: 'dispatch_integration_meta', type: 'dispatch_integration_type' },
];

const orderLabelFor = (orderType) => {
    switch (orderType) {
        case 'will_call':
            return 'Will Call';
        case 'wh_inventory':
            return 'Inventory';
        case 'service':
            return 'Service Callback';
        default:
            return startCase(orderType || 'delivery');
    }
};

/**
 * Modal title bar: order number and type, an open-in-new-tab action, and tracking links.
 *
 * @param {object} props
 * @param {object} props.order The order prop. Links come from its saved values.
 * @param {object} props.clone The draft. The title follows its order number and type.
 * @param {string} [props.title] Replaces the generated title.
 * @param {() => void} props.onClose Called by the close button.
 */
const ModalHeader = ({ order, clone, title, onClose }) => {
    const orderLabel = useMemo(() => orderLabelFor(clone.order_type), [clone.order_type]);

    return (
        <ModalTitle
            title={title || `Order ${clone.order_number || ''} - ${orderLabel}`}
            onClose={onClose}
            actions={[{ Icon: OpenInNew, onClick: () => window.open(`/order/${order.order_id}`, '_blank') }]}
            links={[
                { type: 'Customer', label: order.order_number, link: `/customer/track/${order.order_id}` },
                ...LINK_ATTRS.filter(({ type, meta }) => order[type] && order[meta]?.tracking_number).map(
                    ({ type, meta }) => ({
                        type: order[type],
                        label: order[meta].tracking_number,
                        link: order[meta].tracking_link,
                    })
                ),
            ]}
        />
    );
};

export default ModalHeader;
